const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

export const formatApiError = (error) => {
  const detail = error?.detail;
  if (detail == null) return "Une erreur s'est produite. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: response.statusText }));
    const error = new Error(formatApiError(errorData));
    error.response = { data: errorData, status: response.status };
    throw error;
  }

  return { data: await response.json() };
};

const apiRequest = {
  get: (path, params) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiFetch(`${API_BASE}${path}${qs}`);
  },
  post: (path, data) => apiFetch(`${API_BASE}${path}`, { method: 'POST', body: JSON.stringify(data) }),
  put: (path, data) => apiFetch(`${API_BASE}${path}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (path, { data } = {}) =>
    apiFetch(`${API_BASE}${path}`, {
      method: 'DELETE',
      ...(data !== undefined ? { body: JSON.stringify(data) } : {}),
    })
};

export const productsApi = {
  getCategories: () => apiRequest.get('/products/categories'),
  getProducts: (params) => apiRequest.get('/products/', params),
  getProduct: (id, lang) => apiRequest.get(`/products/${id}`, lang ? { lang } : undefined),
  getProductBySku: (sku, lang) => apiRequest.get(`/products/by-sku/${encodeURIComponent(sku)}`, lang ? { lang } : undefined),
  getMultiplier: (pickupDate, returnDate, pickupTime, returnTime) =>
    apiRequest.get('/products/multiplier/calculate', { pickup_date: pickupDate, return_date: returnDate, pickup_time: pickupTime || 'morning', return_time: returnTime || 'afternoon' }),
  getCatalogRecommendations: (params) => apiRequest.get('/products/catalog-recommendations', params),
  getHolidays: () => apiRequest.get('/products/holidays'),
  getFilters: () => apiRequest.get('/products/filters')
};

export const quotesApi = {
  createQuoteRequest: (data) => apiRequest.post('/quotes/request', data),
  createGuestQuoteRequest: (data) => apiRequest.post('/quotes/guest-request', data),
  getQuotes: () => apiRequest.get('/quotes/'),
  getQuote: (id) => apiRequest.get(`/quotes/${id}`)
};

export const deliveryApi = {
  getConfig: () => apiRequest.get('/delivery/config'),
  calculate: (options) => apiRequest.post('/delivery/calculate', options),
  getZoneFromAddress: (postalCode) => apiRequest.post('/delivery/zone-from-address', { postal_code: postalCode })
};

export const authApi = {
  forgotPassword: (email) => apiRequest.post('/auth/forgot-password', { email }),
  resetPassword: (email, code, new_password) => apiRequest.post('/auth/reset-password', { email, code, new_password }),
  updateProfile: (data) => apiRequest.put('/auth/profile', data),
  changePassword: (old_password, new_password) => apiRequest.post('/auth/change-password', { old_password, new_password }),
  deleteAccount: (password, confirm) => apiRequest.delete('/auth/account', { data: { password, confirm } })
};

export default apiRequest;
